/*@jsxRuntime automatic @jsxImportSource react*/
/*<!-- vale Google.We = NO -->*/
/*Allow for use of "We" in sensitive topics like pricing and security -->*/
/*<!-- vale Google.We = YES -->*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {Docs} from 'components/layout';
import {getIntegrations} from 'api/get-integrations';
import {getExtensions} from 'api/get-extensions';
import {Warning, Tip, Info, WhitelistDetails} from 'ui';
export const title = "Business tier pricing", description = "Learn about Hightouch's Business tier pricing, including platform fee and consumption-based pricing.", lastUpdatedDate = new Date(1685664000000);
export async function getStaticProps() {
  const integrations = await getIntegrations();
  const extensions = await getExtensions();
  return {
    props: {
      ...integrations,
      extensions,
      meta: {
        title: "Business tier pricing",
        description: "Learn about Hightouch's Business tier pricing, including platform fee and consumption-based pricing.",
        lastUpdatedDate: "Fri Jun 02 2023 00:00:00 GMT+0000 (Coordinated Universal Time)",
        slug: null,
        type: null,
        icon: null,
        toc: [{
          "value": "SOC 2 report",
          "depth": 0,
          "id": "soc-2-report"
        }, {
          "value": "Billable destinations",
          "depth": 0,
          "id": "billable-destinations"
        }]
      }
    },
    revalidate: 60
  };
}
const MDXLayout = ({children, ...props}) => _jsx(Docs, Object.assign({}, props, {
  children: children
}));
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      p: "p",
      ul: "ul",
      li: "li",
      strong: "strong",
      a: "a",
      h2: "h2"
    }, _provideComponents(), props.components), {PylonLink} = _components;
    if (!PylonLink) _missingMdxReference("PylonLink", true);
    return _jsxs(_Fragment, {
      children: ["\n", "\n", _jsx(_components.p, {
        children: "Hightouch's Business tier pricing varies depending on your use case and required features.\nIt typically includes:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["A ", _jsx(_components.strong, {
            children: "platform fee"
          }), ", which could include consumption-based pricing or the billable ", _jsx(_components.a, {
            href: "/pricing/ss-pricing#destinations",
            children: "destinations"
          }), " to which you sync data."]
        }), "\n", _jsxs(_components.li, {
          children: ["Costs for ", _jsx(_components.strong, {
            children: "feature add-ons"
          }), ", such as various ", _jsx(_components.a, {
            href: "/customer-studio/overview",
            children: "Customer Studio"
          }), " features or the ", _jsx(_components.a, {
            href: "/destinations/personalization-api",
            children: "Personalization API"
          }), "."]
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: "This allows us to create a plan that fits your specific feature usage and consumption needs."
      }), "\n", _jsxs(_components.p, {
        children: ["For the complete list of features included in Business tier packages, please visit our ", _jsx(_components.a, {
          href: "https://hightouch.com/pricing",
          children: "pricing page"
        }), ".\nDon't hesitate to ", _jsx(PylonLink, {
          pylonText: "Hi, I'm interested in learning more about the Business tier plan.",
          linkText: "get in touch"
        }), " to receive a quote or discuss whether the Business tier is a good fit for you."]
      }), "\n", "\n", _jsx(_components.h2, {
        id: "soc-2-report",
        children: "SOC 2 report"
      }), "\n", _jsxs(_components.p, {
        children: ["If you are an existing Hightouch Business Tier customer, you can request a copy of our full SOC 2 report at the ", _jsx(_components.a, {
          href: "https://trust.hightouch.com/",
          children: "Hightouch Trust Center"
        }), ".\nIf you are not yet a Business Tier customer but are considering buying Business Tier, we can provide you the report under NDA."]
      }), "\n", _jsx(_components.h2, {
        id: "billable-destinations",
        children: "Billable destinations"
      }), "\n", _jsx(_components.p, {
        children: "In sync-based pricing, all destinations are billable and syncs from each destination are counted equally."
      })]
    });
  }
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
